import React from 'react';
import OmButton from '../../../../components/ui/OmButton';

/**
 * ExportButton Component
 * 
 * Handles CSV export functionality for audit logs with loading state.
 * Replaces the legacy HTML button with OM Design System OmButton component.
 * Maintains exact same export behavior and user experience.
 * 
 * @param {Object} props - Component props
 * @param {Function} props.onExport - Function to handle export action
 * @param {boolean} props.isLoading - Whether export is in progress
 * @param {boolean} props.disabled - Whether button should be disabled
 * @param {string} [props.className] - Additional CSS classes
 */
const ExportButton = ({ 
  onExport, 
  isLoading = false, 
  disabled = false, 
  className = '' 
}) => {
  /**
   * Handle button click
   */
  const handleClick = () => {
    if (!isLoading && !disabled && onExport) {
      onExport();
    }
  };

  return (
    <OmButton
      buttonType="outlined-button"
      buttonSize="medium"
      onClick={handleClick}
      disabled={isLoading || disabled}
      className={`flex items-center ${className}`}
    >
      {isLoading ? (
        <>
          <svg 
            className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" 
            fill="none" 
            viewBox="0 0 24 24"
          >
            <circle 
              className="opacity-25" 
              cx="12" 
              cy="12" 
              r="10" 
              stroke="currentColor" 
              strokeWidth="4"
            />
            <path 
              className="opacity-75" 
              fill="currentColor" 
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          Exporting...
        </>
      ) : (
        "Export CSV"
      )}
    </OmButton>
  );
};

export default ExportButton;